import type { GetServerSideProps } from "next";

import type { LocationMapType } from "@widgets/contact-map-card";

import type { TableBlockType } from "@features/article-content/model";

import { loadPageWithGlobal } from "@shared/api";

import { MerchPage } from "@/_pages/merch";
import { getMerchPage } from "@/_pages/merch/api";
import type { MerchType } from "@/_pages/merch/model";

type Params = {
  slug: string;
};

type PageProps = {
  cms: {
    merch: MerchType;
    pageData: {
      sizeTable: TableBlockType;
      popupTitle: string;
      popupDescription: string;
      contactMapSection: LocationMapType;
    };
  };
};

const Page = (props: PageProps) => {
  const { cms } = props;

  return (
    <MerchPage
      merch={cms.merch}
      contactMapSection={cms.pageData.contactMapSection}
      popupData={{
        tableSize: cms.pageData.sizeTable,
        popup: {
          title: cms.pageData.popupTitle,
          description: cms.pageData.popupDescription,
        },
      }}
    />
  );
};

export const getServerSideProps: GetServerSideProps<{}, Params> = async (
  context,
) => {
  const { res } = context;
  const { slug } = context.params!;

  return await loadPageWithGlobal(
    async () => {
      const cms = await getMerchPage(slug);

      return {
        ...cms,
      };
    },
    { res },
  );
};

export default Page;
